import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'customFilter'
})
export class CustomFilterPipe implements PipeTransform {
  customFilterArray: any = [];
  object: any = {};

  transform(searchingArray: Array<any>, filterValue: string) {
    if (!filterValue) {
      return searchingArray;
    }
    return searchingArray.filter((item) => {
      if (Array.isArray(item)) {
        return item.some((value) => {
          if (Array.isArray(value)) {
            return value.some((subValue) => {
              return this.stringFilter(subValue, filterValue);
            });
          } else if (typeof value === 'string') {
            return value.toLowerCase().includes(filterValue.toLowerCase());
          }
          return false;
        });
      } else if (typeof item === 'object') {
        return Object.values(item).some((value) => {
          return this.stringFilter(value, filterValue);
        });
      }
      return false;
    });  
  }

  stringFilter(value, filterValue){
    if (/^\d+$/.test(filterValue)) {
      const modifiedFilterValue = filterValue.replace(/\D/g, '');
      if (typeof value === 'string') {
        const numberWithoutChar = value.replace(/\D/g, '');
        return numberWithoutChar.includes(modifiedFilterValue);
      }
      return false;
    } else {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(filterValue.toLowerCase());
      }
      return false;
    }
  }

}
